import api from '@/lib/hippo'
import Vue from 'vue'
import Folder from '@/models/folder'
import Message from '@/models/message'

function initialState() {
    return {
        folders: {},
        messages: {},
        message: {},
        message_count: 0
    };
}

const state = initialState;

const getters = {
    folders: (state) => state.folders,
    internalFolderId: (state) => (folderId) => (state.folders) ? state.folders.map( (x) => x.id ).indexOf(folderId) : -1,
    typeFolders: (state) => (typeId) => (state.folders && state.folders.length > 0) ? state.folders.filter(f => f.type_id == typeId) : [],
    inboxUnread: (state) => (state.folders && state.folders.length > 0) ? state.folders.filter(f => f.type_id == 40)[0].unread_count : 0,
    messages: (state) => state.messages.messages,
    message: (state) => state.message
};

const actions = {

    fetchFolders( {commit, rootGetters}) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.getFolders(rootGetters.apiToken)
                   .then((response) => {
                      commit ('setFolders', Folder.from(response.data) );
                      resolve(true);
                   }).catch((err) => reject(err));
            } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
        });
    },
    fetchMessages( {commit, rootGetters}, {folderid, page, per_page}) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken && folderid && page && per_page) {
                api.getMessages(rootGetters.apiToken, folderid, page, per_page)
                   .then( (response) => {
                       commit ('setMessages', Message.from(response.data) );
                       commit ('setMessageCount', response.data.meta.total_count );
                       resolve(true);
                   }).catch( (err) => reject(err) );
            } else {
                reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
            }
        });
    },
    fetchMessage( {rootGetters, commit}, {folderId, messageId} ) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.getMessage(rootGetters.apiToken, folderId, messageId)
                   .then( (response) => {
                       commit ('setMessage', Message.from(response.data));
                       resolve(true);
                   })
                   .catch( (err) => reject(err) );
            } else {
                reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
            }
        });
    },
    delMessage( {rootGetters, commit}, {folderId, messageId} ) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.deleteMessage(rootGetters.apiToken, folderId, messageId)
                    .then((response) => {
                        commit('removeMessages', [messageId]);
                        resolve(true);
                    })
                   .catch((err) => reject(err));
            } else {
                reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
            }
        });
    },
    unDeleteMessage( {commit, getters, rootGetters}, {folderId, messageId} ) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.restoreMessage(rootGetters.apiToken, folderId, messageId)
                    .then((response) => {
                        commit('removeMessages', [messageId]);
                        resolve(true);
                    })
                   .catch((err) => reject(err));
            } else {
                reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
            }
        });
    },
    createDraft( {commit, rootGetters}, message ) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.postDraft(rootGetters.apiToken, message)
                   .then( (response) => {
                       let msg = Message.from(response.data);
                       //commit ('setMessage', Message.from(response.data));
                       resolve(msg);
                   }).catch( (err) => reject(err) );
            } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
        });
    },
    saveDraft( {commit, getters, rootGetters}, message ) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.putDraft(rootGetters.apiToken, message)
                .then( (response) => {
                    //commit ('setMessage', Message.from(response.data));
                    // Dispatch(root) to Users Store - to store user objects for quick retreival
                    resolve(true);
                }).catch( (err) => reject(err) );
            } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
      });
    },
    sendMessage( {commit, rootGetters}, message ) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.postMessage(rootGetters.apiToken, message)
                   .then((response) => {
                       commit('setMessage', null);
                       resolve(true);
                   }).catch( (err) => reject(err));
            } else {
                reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
            }
        });
    },
    moveMessages({commit, rootGetters}, {folderId, destFolderId, messages}) {
      return new Promise((resolve, reject) => {
          if (rootGetters.apiToken) {
              api.putMoveMessages(rootGetters.apiToken, folderId, destFolderId, messages)
                 .then((response) => {
                     commit('removeMessages', messages);
                     resolve(true);
                 }).catch( (err) => reject(err));
          } else {
              reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
          }
      });
    },
    newFolder( {commit, getters, rootGetters}, {name} ) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
				let folder = new Folder ({name: name});
                api.saveFolder(rootGetters.apiToken, folder)
               .then((response) => {
                   commit('addNewFolder', Folder.from(response.data));
                   resolve(true);
               })
               .catch((err) => reject(err));
            } else {
                reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
            }
        });
    },
    saveFolder( {commit, getters, rootGetters}, {folderId, name} ) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
				let folder = new Folder ({id: folderId, name: name});
                api.saveFolder(rootGetters.apiToken, folder)
               .then((response) => {
                   commit('setFolderName', {folderId: getters.internalFolderId(folderId), name});
                   resolve(true);
               })
               .catch((err) => reject(err) );
            } else {
                reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
            }
        });
    },
    destroyFolder( {commit, getters, rootGetters}, folderId ) {
      return new Promise((resolve, reject) => {
          if (rootGetters.apiToken) {
              api.deleteFolder(rootGetters.apiToken, folderId)
             .then((response) => {
                 commit('removeFolder', getters.internalFolderId(folderId));
                 resolve(true);
             })
             .catch((err) => reject(err));
          } else {
              reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
          }
      });
    },
    resetMessagesState({commit}) {
        commit('resetState');
    }
};

const mutations = {
    setFolders: (state, folders) => {
        Vue.set(state, 'folders', folders);
    },
    setFolderName: (state, {folderId, name}) => {
        Vue.set(state.folders[folderId], 'name', name);
    },
    removeFolder: (state, folderId) => {
        Vue.delete(state.folders, folderId);
    },
    addNewFolder: (state, folder) => {
        state.folders.push(folder);
    },
    setMessages: (state, messages) => {
        Vue.set(state, 'messages', messages);
    },
    setMessageCount: (state, count) => {
		Vue.set(state, 'message_count', count);
	},
    setMessage: (state, message) => {
        Vue.set(state, 'message', message);
    },
    removeMessages: (state, messages) => {
        messages.forEach(function(mid, key) {
            Vue.delete(state.messages, mid);
        });
    },
    resetState (state) {
        const s = initialState();
        Object.keys(s).forEach(key => {
            Vue.set(state, key, s[key]);
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
